
import React, { useState, useReducer } from 'react';
import CryptoJS from "crypto-js";

if (sessionStorage.getItem("milso")) {
	const storedData = sessionStorage.getItem("milso");
	var bytes = CryptoJS.AES.decrypt(storedData, 'RangaFulan09');
	var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	// console.log("decryptedData",decryptedData)

}

let token = decryptedData ? decryptedData.access_token : '';
let UserID = decryptedData ? decryptedData.TableUserID : '';
let UserFullName = decryptedData ? decryptedData.UserFullName : '';
let UserName = decryptedData ? decryptedData.UserName : '';

export const initialState = {
	token: '' || token,
	UserID: '' || UserID,
	UserFullName: '' || UserFullName,
	UserName : '' || UserName,
	profile: decryptedData || {},
	loading: false,
	errorMessage: null,
};

export const AuthReducer = (initialState, action) => {
	// console.log(action.payload)

	switch (action.type) {
		case 'REQUEST_LOGIN':
			return {
				...initialState,
				loading: true,
			};
		case 'LOGIN_SUCCESS':
			return {
				...initialState,
				token: action.payload.access_token,
				UserID: action.payload.TableUserID,
				UserFullName: action.payload.UserFullName,
				UserName: action.payload.UserName,
				profile: action.payload,
				loading: false,
			};
		case 'LOGOUT':
			return {
				...initialState,
				token: '',
				UserID: '',
				UserFullName: '',
				UserName:'',
				profile: {},
			};

		case 'LOGIN_ERROR':
			return {
				...initialState,
				loading: false,
				errorMessage: action.error,
			};

		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};
